import React, { ReactElement } from 'react'
import CommonSectionItem, {
  CustomImage,
} from 'components/Organization/LandingPageCommonComponents/CommonSectionItem'
import ContentFilteringImage from 'images/organization/industries/schools/content-filtering-2.svg'
import { Text } from 'theme-ui'
import StyledLink from 'components/Organization/LandingPageCommonComponents/StyledLink'

export default function ContentFilteringFeatures(): ReactElement {
  return (
    <CommonSectionItem
      isReverse
      customImage={
        <CustomImage
          svg={ContentFilteringImage}
          descriptiveText="Control D’s content filtering features illustration"
        />
      }
      title="Control D’s content filtering features"
      description={
        <>
          <Text>
            With Control D’s{' '}
            <StyledLink to="/features/web-filtering/">powerful content filtering</StyledLink>,
            school administrators can customize and enforce safe browsing policies with ease.
          </Text>
          <Text sx={{ display: 'inline-flex', mt: '1.6rem' }}>
            Control D uses advanced AI and real-time filtering to block harmful content, manage
            classroom internet access, and keep your school compliant.
          </Text>
        </>
      }
      sx={{
        mt: ['8rem', '12rem'],
        px: [0, '1.6rem', 0],
      }}
    />
  )
}
